import React from "react";
import styles from "../../styles/Blog/Blog.module.css";
import PopularPost from "./PopularPost";

const PopularPosted = ({ blogs }) => {
  return (
    <div>
      <div className={styles.featuredTitle}>Popular Posted</div>
      <div className={styles.popularPostsContainer}>
        {blogs.map((blog, index) => (
          <PopularPost data={blog} key={index} />
        ))}
      </div>
    </div>
  );
};

export default PopularPosted;
